import { useEffect } from "react";
import router from "umi/router";
import { connect } from "dva";
import { getLocalStorage } from "@/utils/storage";

const SecurityLayout = ({ children, dispatch, isLoading, configFetched, currentUserId }) => {
  let dataAuth = getLocalStorage("dataAuth");
  let token = dataAuth?.access_token;

  useEffect(() => {
    const dataAuth = getLocalStorage("dataAuth");
    const token = dataAuth?.access_token;

    if (dispatch) {
      dispatch({
        type: "user/saveUserManager",
        payload: { userManager: token },
      });
    }
  }, []);

  if (!token && configFetched && !isLoading && !currentUserId) {
    router.push("/user/login");
    return null;
  }

  return children;
};

export default connect(({ loading, configs, user }) => ({
  isLoading: loading.effects["configs/getConfigData"],
  configFetched: configs.configFetched,
  currentUserId: user?.currentProfile?.id,
}))(SecurityLayout);
